import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

export default function SilkCabsFooter() {
  return (
    <Container>
      <div className="footer-container">
        <div className="footer">
          <ul className="footer-list">
            <li>
              <Link to={"/about-us"} className="footer-link">
                About Us
              </Link>
            </li>
            <li style={{ marginTop: "1rem" }}>
              <Link to={"/gosawari-refund-policy"} className="footer-link">
                Refund and Cancellation
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer">
          <ul className="footer-list">
            <li>
              <Link to={"/contact-us"} className="footer-link">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer">
          <ul className="footer-list">
            <li>
              <Link to={"/terms-conditions"} className="footer-link">
                Terms and Conditions
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer">
          <ul className="footer-list">
            <li>
              <Link to={"/privacy-policy"} className="footer-link">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>

        <div className="copyrights">
          <p>
            <span>&copy;</span> 2025 GoSawari.com. All rights reserved.
          </p>
          {/* <p>NTN:E866598-6</p> */}
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  padding: 2rem 1rem;
  background-color: #ededed;
  width: 100%;
  height: auto;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 2rem;

    @media (max-width: 768px) {
      justify-content: space-around;
      gap: 1.5rem;
    }

    @media (max-width: 480px) {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1.5rem;
    }
  }

  .footer {
    min-width: 200px;

    @media (max-width: 480px) {
      min-width: unset;
      width: 100%;
    }
  }

  .footer-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 0.5rem;
    }
  }

  .footer-link {
    text-decoration: none;
    color: #455a64;
    cursor: pointer;
    display: inline-block;
    transition: color 0.3s ease;
    font-size: 0.95rem;

    &:hover {
      color: #00b5ff;
    }
  }

  .copyrights {
    width: 100%;
    padding-top: 2rem;
    margin-top: 1rem;
    border-top: 1px solid #d0d0d0;
    text-align: center;

    p {
      font-size: 0.9rem;
      color: #798e9b;
      margin: 0;

      span {
        font-weight: bold;
      }
    }
  }
`;
